<template>
  <ClientOnly
    ><div
      ref="targetRef"
      class="editor-image__parent-flex"
      :class="[
        ['align-left', 'align-center', 'align-right'].includes(position)
          ? position
          : '',
        {
          'float-left': isFloatAvailable && position === 'float-left',
          'float-right': isFloatAvailable && position === 'float-right',
        },
      ]"
      :style="[
        { width: !isMobile && styles.width ? `${styles.width}px` : null },
      ]"
    >
      <div
        class="editor-content-image__wrapper editor-wrapper"
        :class="{ editable }"
      >
        <div class="editor-content-image">
          <Component
            :is="containerTag"
            v-bind="containerAttrs"
            class="editor-content-image__container"
          >
            <div
              v-if="editable && !widthChangeDisabled"
              class="editor-content-image__resizer"
              @mousedown="handleMouseDown"
            >
              <SvgIcon name="editor/resizer" />
            </div>
            <img
              v-lazy-load
              :src="imageSrc"
              :alt="description"
              @load="handleCalcFloat"
            />
          </Component>

          <div class="editor-content-image__footer">
            <EditorContentEditable
              v-if="editable || description"
              class="editor-content-image__description"
              tag="span"
              :contenteditable="editable"
              placeholder="Подпись к фотографии"
              :text="description"
              @blur="handleDescriptionBlur"
            ></EditorContentEditable>
            <div v-if="editable || source" class="editor-content-image__source">
              Источник:
              <EditorContentEditable
                tag="span"
                :contenteditable="editable"
                placeholder="ссылка на источник"
                :text="source"
                @blur="handleSourceBlur"
              ></EditorContentEditable>
            </div>
          </div>
        </div>

        <EditorContentImageEdit
          v-if="editable"
          ref="contentImageEditRef"
          class="content-image-edit"
          :class="{ isleft: isleft }"
          :activities="activities"
          :disabled-options="disabledOptions"
          @update:position="handleUpdatePosition"
          @delete="handleDelete"
        />
      </div></div
  ></ClientOnly>
</template>

<script>
const MIN_WIDTH = 80;
const MAX_WIDTH = 660;
</script>

<script setup>
const props = defineProps({
  editable: { type: Boolean, default: false },
  imageSrc: { type: String, required: true },
  description: { type: [String, Number], default: null },
  source: { type: [String, Number], default: null },
  position: { type: String, default: null },
  width: { type: [String, Number], default: null },
  maxWidth: {
    type: Number,
    default: MAX_WIDTH,
  },
  disabledOptions: { type: Array, default: () => [] },
  marks: { type: Array, default: () => [] },
});

const emit = defineEmits([
  'update:imageSrc',
  'update:description',
  'update:source',
  'update:position',
  'update:width',
  'delete',
]);

const { isMobile } = useBreakpoint();

const isFloatAvailable = ref(false);
const contentImageEditRef = ref(null);
const targetRef = ref(null);
const styles = ref({
  width: props.width,
});

/** computed */
const linkMark = computed(() => {
  return props.marks.find((mark) => mark.type === 'link');
});

const containerTag = computed(() => {
  return linkMark.value ? 'a' : 'div';
});

const containerAttrs = computed(() => {
  return props.marks.reduce((attrs, mark) => {
    return { ...attrs, ...mark.attrs };
  }, {});
});

const widthChangeDisabled = computed(() => {
  return props.disabledOptions.includes('width');
});

const activities = computed(() => {
  return [props.position].filter((el) => !!el);
});

const isleft = computed(() => {
  return styles.value.width <= contentImageEditRef.value?.$el?.offsetWidth;
});
/** // computed */

const handleMouseDown = () => {
  targetRef.value.style.userSelect = 'none';
  document.addEventListener('mousemove', handleMouseMove);
  document.addEventListener('mouseup', handleMouseUp, { once: true });
};

const handleCalcFloat = () => {
  isFloatAvailable.value = styles.value.width < props.maxWidth - 50;
};

const handleMouseUp = () => {
  targetRef.value.style.userSelect = '';
  const width = targetRef.value.offsetWidth;
  const max = props.maxWidth;

  if (width > max - 50) {
    styles.value.width = max;
  }

  document.removeEventListener('mousemove', handleMouseMove);

  emit('update:width', targetRef.value.offsetWidth);
  handleCalcFloat();
};

const handleMouseMove = (e) => {
  const width = targetRef.value.offsetWidth;
  const max = props.maxWidth;
  const min = MIN_WIDTH;

  if (width < min) {
    styles.value.width = min;
    return;
  }

  if (width > max) {
    styles.value.width = max;
    return;
  }

  styles.value.width = width + e.movementX;
};

const handleDescriptionBlur = (e) => {
  emit('update:description', e.target.innerText);
};

const handleSourceBlur = (e) => {
  emit('update:source', e.target.innerText);
};

const handleUpdatePosition = (position) => {
  emit('update:position', position);
};

const handleDelete = () => {
  emit('delete');
};
</script>
